import { hasRole } from "@/helpers/user";
import Input from "../Input";
import Label from "../Label";
import Select from "../Select";
import Button from "../Button";

const Form = ({ onSubmit, onChange, onSelect, data, branchOffices, processing, auth }) => {
    const handleSubmit = (event) => {
        onSubmit && onSubmit(event);
    }

    const handleChange = (event) => {

        const values = {
            'checkbox': Boolean(event.target.checked),
            'number': parseInt(event.target.value),
            'default': event.target.value
        };

        const value = values[event.target.type] || values['default'];

        onChange && onChange({
            name: event.target.name,
            value,
        });
    }

    const handleSelect = (name, { value }) => {
        onSelect && onSelect({ name, value });
    }

    const getManualStockLabel = (type) => {
        const labels = {
            'schedule': 'Stock por hora',
            'day': 'Stock por día'
        };

        return labels[type] || null;
    }

    return (
        <form onSubmit={handleSubmit} className="p-4 mt-8 max-w-3xl mx-auto">
            <div className="grid grid-cols-1 w-full gap-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <Label forInput="name" value="Nombre del producto" />
                        <Input
                            name="name"
                            handleChange={handleChange}
                            value={data.name}
                            type="text"
                            className="w-full"
                        />
                    </div>
                    <div>
                        <Label forInput="price" value="Precio del producto" />
                        <Input
                            name="price"
                            handleChange={handleChange}
                            value={data.price}
                            type="number"
                            className="w-full"
                            min={0}
                        />
                    </div>
                    <div>
                        <Label forInput="softland_id" value="Codigo de Softland" />
                        <Input
                            name="softland_id"
                            handleChange={handleChange}
                            value={data.softland_id}
                            type="text"
                            className="w-full"
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-4">
                    <div>
                        <Label forInput="description" value="Descripción del producto" />
                        <textarea
                            rows={4}
                            name="description"
                            onChange={handleChange}
                            value={data.description}
                            type="text"
                            className="w-full resize-none border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-4">
                    <Select
                        id="branch_office_id"
                        styles={{
                            indicatorSeparator: () => ({ display: "none" }),
                            input: (styles) => ({
                                ...styles,
                                "> input": {
                                    boxShadow: "none !important",
                                },
                            }),
                        }}
                        className="col-span-8 rounded-md shadow-none"
                        options={branchOffices?.map(branchOffice => {
                            return {
                                value: branchOffice.id,
                                label: branchOffice.name
                            }
                        })}
                        value={
                            data.branch_office_id && Boolean(branchOffices.length)
                                ? {
                                    value: data.branch_office_id,
                                    label: branchOffices.find(({ id }) => id === data.branch_office_id).name,
                                }
                                : {
                                    value: null,
                                    label: "Seleccione una sucursal",
                                }
                        }
                        isDisabled={!hasRole(auth.user, 'super_admin')}
                        noOptionsMessage={() =>
                            "No hay sucursales disponibles"
                        }
                        onChange={(value) => handleSelect('branch_office_id', value)}
                    />
                </div>
                <div className="grid grid-cols-1 gap-4">
                    <div>
                        <Label forInput="max" value="Cantidad máxima" />
                        <Input
                            placeholder={data.max_by_tickets_number ? 'Por cantidad de tickets' : 'Ilimitados'}
                            name="max"
                            min={0}
                            handleChange={handleChange}
                            value={data.max}
                            type="number"
                            disabled={data.max_by_tickets_number}
                        />
                    </div>
                    <div className="flex items-center gap-2">
                        <Input
                            id="max_by_tickets_number"
                            name="max_by_tickets_number"
                            handleChange={handleChange}
                            type="checkbox"
                            checked={data.max_by_tickets_number}
                        />
                        <Label forInput="max_by_tickets_number" value="Igual a la cantidad de tickets" />
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <Label forInput="manual_stock" value="Stock manual" />
                        <Input
                            placeholder={data.limit_per_schedule}
                            name="manual_stock"
                            handleChange={handleChange}
                            value={data.manual_stock}
                            type="number"
                            className="w-full"
                        />
                    </div>
                    <div>
                        <Label forInput="manual_stock_type" value="Periodo de stock manual" />
                        <Select
                            id="manual_stock_type"
                            styles={{
                                indicatorSeparator: () => ({ display: "none" }),
                                input: (styles) => ({
                                    ...styles,
                                    "> input": {
                                        boxShadow: "none !important",
                                    },
                                }),
                            }}
                            className="rounded-md shadow-none w-full"
                            options={[
                                {
                                    value: 'schedule',
                                    label: getManualStockLabel('schedule')
                                },
                                {
                                    value: 'day',
                                    label: getManualStockLabel('day')
                                }
                            ]}
                            value={data.manual_stock_type ? ({
                                value: data.manual_stock_type,
                                label: getManualStockLabel(data.manual_stock_type)
                            }) : ({
                                value: null,
                                label: ''
                            })}
                            isDisabled={!hasRole(auth.user, 'super_admin')}
                            noOptionsMessage={() =>
                                "No hay sucursales disponibles"
                            }
                            onChange={(value) => handleSelect('manual_stock_type', value)}
                        />
                    </div>
                </div>
            </div>
            <Button processing={processing}>Guardar</Button>
        </form>
    );
};

export default Form;
